import { Button, Modal } from 'antd';
import { useEffect, useRef } from 'react';

const MAPA_HIGHLIGHTS = {
  rfc: { top: '23%', left: '2.5%', width: '65%', height: '4.5%' },
  razon_social: { top: '27.5%', left: '3.5%', width: '65%', height: '3.5%' },
  codigo_postal: { top: '46.5%', left: '4%', width: '42.5%', height: '4.5%' },
  regimen_fiscal: { top: '92%', left: '4%', width: '68%', height: '4.5%' },
};

const imagenBaseCIF = `${process.env.PUBLIC_URL}/cif_ejemplo.png`;

export const CifHelpModal = ({ isModalOpen, setIsModalOpen, campoActivo }) => {
  const highlightRef = useRef(null);

  useEffect(() => {
    if (isModalOpen && campoActivo && highlightRef.current) {
      setTimeout(() => {
        highlightRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 150);
    }
  }, [isModalOpen, campoActivo]);

  return (
    <Modal
      title="Guía de ayuda: ¿Dónde encontrar este dato?"
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      footer={[
        <Button key="close" type="primary" onClick={() => setIsModalOpen(false)}>
          Entendido
        </Button>
      ]}
      width={700}
    >
      <div className="contenedor-cif-guia">
        <img src={imagenBaseCIF} alt="Guía CIF" className="imagen-cif-base" />
        {campoActivo && MAPA_HIGHLIGHTS[campoActivo] && (
          <div
            ref={highlightRef}
            className="dinamic-highlight-box"
            style={{
              top: MAPA_HIGHLIGHTS[campoActivo].top,
              left: MAPA_HIGHLIGHTS[campoActivo].left,
              width: MAPA_HIGHLIGHTS[campoActivo].width,
              height: MAPA_HIGHLIGHTS[campoActivo].height,
            }}
          />
        )}
      </div>
    </Modal>
  );
};
